import * as tslib_1 from "tslib";
import { GraphQueryableInstance, GraphQueryableCollection, defaultPath } from "./graphqueryable";
import { jsS } from "@pnp/common";
/**
 * Represents a onenote entity
 */
var OneNote = /** @class */ (function (_super) {
    tslib_1.__extends(OneNote, _super);
    function OneNote() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(OneNote.prototype, "notebooks", {
        get: function () {
            return new Notebooks(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OneNote.prototype, "sections", {
        get: function () {
            return new Sections(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OneNote.prototype, "pages", {
        get: function () {
            return new Pages(this);
        },
        enumerable: true,
        configurable: true
    });
    OneNote = tslib_1.__decorate([
        defaultPath("onenote")
    ], OneNote);
    return OneNote;
}(GraphQueryableInstance));
export { OneNote };
/**
 * Describes a collection of Notebook objects
 *
 */
var Notebooks = /** @class */ (function (_super) {
    tslib_1.__extends(Notebooks, _super);
    function Notebooks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets a notebook instance by id
     *
     * @param id Notebook id
     */
    Notebooks.prototype.getById = function (id) {
        return new Notebook(this, id);
    };
    /**
     * Create a new notebook as specified in the request body.
     *
     * @param displayName Notebook display name
     */
    Notebooks.prototype.add = function (displayName) {
        var _this = this;
        var postBody = {
            displayName: displayName,
        };
        return this.postCore({
            body: jsS(postBody),
        }).then(function (r) {
            return {
                data: r,
                notebook: _this.getById(r.id),
            };
        });
    };
    Notebooks = tslib_1.__decorate([
        defaultPath("notebooks")
    ], Notebooks);
    return Notebooks;
}(GraphQueryableCollection));
export { Notebooks };
/**
 * Describes a notebook instance
 *
 */
var Notebook = /** @class */ (function (_super) {
    tslib_1.__extends(Notebook, _super);
    function Notebook(baseUrl, path) {
        return _super.call(this, baseUrl, path) || this;
    }
    Object.defineProperty(Notebook.prototype, "sections", {
        get: function () {
            return new Sections(this);
        },
        enumerable: true,
        configurable: true
    });
    return Notebook;
}(GraphQueryableInstance));
export { Notebook };
/**
 * Describes a collection of Sections objects
 *
 */
var Sections = /** @class */ (function (_super) {
    tslib_1.__extends(Sections, _super);
    function Sections() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets a section instance by id
     *
     * @param id Section id
     */
    Sections.prototype.getById = function (id) {
        return new Section(this, id);
    };
    /**
     * Adds a new section
     *
     * @param displayName New section display name
     */
    Sections.prototype.add = function (displayName) {
        var _this = this;
        var postBody = {
            displayName: displayName,
        };
        return this.postCore({
            body: jsS(postBody),
        }).then(function (r) {
            return {
                data: r,
                section: _this.getById(r.id),
            };
        });
    };
    Sections = tslib_1.__decorate([
        defaultPath("sections")
    ], Sections);
    return Sections;
}(GraphQueryableCollection));
export { Sections };
/**
 * Describes a sections instance
 *
 */
var Section = /** @class */ (function (_super) {
    tslib_1.__extends(Section, _super);
    function Section(baseUrl, path) {
        return _super.call(this, baseUrl, path) || this;
    }
    return Section;
}(GraphQueryableInstance));
export { Section };
/**
 * Describes a collection of Pages objects
 *
 */
var Pages = /** @class */ (function (_super) {
    tslib_1.__extends(Pages, _super);
    function Pages() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Pages = tslib_1.__decorate([
        defaultPath("pages")
    ], Pages);
    return Pages;
}(GraphQueryableCollection));
export { Pages };
//# sourceMappingURL=onenote.js.map